// Kundekonto (customer credit) decisions for the sale payment picker.
// Pure functions only: never mutate the sale or the customer passed in.
// Mirrors backend/lib/visitor-credit.js (tolerance 0.5).

const TOLERANCE = 0.5;

export function isEnabled(customer) {
    if (!customer || !customer.featureFlags) return false;
    return parseInt(customer.featureFlags.customerCredit, 10) === 1;
}

// Decide which kundekonto button (if any) to show and the amount it posts.
// return: the sale total is negative (a return) and there is something left to settle.
// use:    the sale is positive, the visitor has credit, and something is left to pay.
//         When the balance covers the rest the exact rest is posted (full payment).
//         Otherwise a whole-krone partial is posted, matching the partial-payment input.
export function creditButton({ enabled, hasVisitor, total, rest, balance }) {
    if (!enabled || !hasVisitor) return null;
    const t = total || 0;
    const r = rest || 0;
    const b = balance || 0;
    if (t < 0 && r !== 0) {
        return { mode: 'return', amount: r };
    }
    if (t > 0 && b > 0 && r > 0) {
        if (b + TOLERANCE >= r) {
            return { mode: 'use', amount: r };
        }
        if (Math.floor(b) === 0) {
            return null;
        }
        return { mode: 'use', amount: Math.floor(b) };
    }
    return null;
}

export function isPartial(amount, rest) {
    return amount < rest - TOLERANCE;
}
